module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-resetpwd"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ResetPwd.t1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd1),
      expression: "nPwd1"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.nPwd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd2),
      expression: "nPwd2"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.nPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "sl-error-msg"
  }, [_vm._v("* " + _vm._s(_vm.$t('Views.ResetPwd.err')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Views.ResetPwd.t2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rPwd1),
      expression: "rPwd1"
    }],
    class: {
      'sl-error': _vm.rError
    },
    attrs: {
      "type": "password",
      "placeholder": "Refund password"
    },
    domProps: {
      "value": (_vm.rPwd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rPwd1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rPwd2),
      expression: "rPwd2"
    }],
    class: {
      'sl-error': _vm.rError
    },
    attrs: {
      "type": "password",
      "placeholder": "Confirm refund password"
    },
    domProps: {
      "value": (_vm.rPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rPwd2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rError),
      expression: "rError"
    }],
    staticClass: "sl-error-msg"
  }, [_vm._v("* " + _vm._s(_vm.$t('Views.ResetPwd.err')))]), _vm._v(" "), _c('button', {
    class: {
      'disable-btn': _vm.disableBtn
    },
    attrs: {
      "disabled": _vm.disableBtn
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a1d5f3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/on-boarding/reset-password.vue
// module id = 1101
// module chunks = 1